import { InlineEditor } from "./InlineEditor";
import type { EditorProps } from "./editorProps";

export const NumberEditor = (props: EditorProps) => (
    <InlineEditor {...props} align="end" inputMode="decimal" />
);
